// One colour per connected mailbox, shared so the same address is the same
// colour in the Unibox, in a thread and on the mailboxes chart.
export const MAILBOX_HUES = ['var(--accent)', '#7c3aed', '#16a34a', '#ea580c', '#0891b2', '#db2777'];

export function mailboxColor(accounts, accountId) {
  const index = accounts.findIndex((account) => account.id === accountId);
  return MAILBOX_HUES[(index < 0 ? 0 : index) % MAILBOX_HUES.length];
}
